module.exports = __webpack_public_path__ + "img/upload-to-cloud.d71e42a4.gif";